import React, {useState} from 'react';
import {StyleSheet, css} from 'aphrodite';

import AllOutlets from '../components/home/AllOutlets';
import TopTabsWeb from '../components/home/TopTabsWeb';

const logo = '/logo192.png';

const HomePage = () => {
  const [selectedTab, setSelectedTab] = useState('Delivery');

  return (
    <div className={css(styles.page)}>
      <main className={css(styles.shell)}>
        <section className={css(styles.hero)}>
          <div className={css(styles.heroTextBlock)}>
            <p className={css(styles.kicker)}>YaBatho Customer Web App</p>

            <h1 className={css(styles.title)}>Local food, made easier.</h1>

            <p className={css(styles.subtitle)}>
              Browse available outlets, choose how you want to order, and
              support local restaurants through YaBatho.
            </p>
          </div>

          <div className={css(styles.heroBadge)}>
            <img
              src={logo}
              alt="YaBatho Logo"
              className={css(styles.heroLogoImage)}
            />
          </div>
        </section>

        <section className={css(styles.contentCard)}>
          <TopTabsWeb onSelect={setSelectedTab} selectedTab={selectedTab} />

          <div className={css(styles.outletHeader)}>
            <div>
              <p className={css(styles.sectionKicker)}>Available Outlets</p>

              <h2 className={css(styles.sectionTitle)}>
                {selectedTab === 'Delivery' && 'Order for delivery'}
                {selectedTab === 'Pick-up' && 'Order for pick-up'}
                {selectedTab === 'Dine-in' && 'Order for dine-in at the restaurant'}
              </h2>
            </div>

            <span className={css(styles.modePill)}>{selectedTab}</span>
          </div>

          <AllOutlets selectedTab={selectedTab} />
        </section>
      </main>
    </div>
  );
};

const styles = StyleSheet.create({
  page: {
    minHeight: '100vh',
    width: '100%',
    backgroundColor: '#FFFDF7',
    color: '#0F3D2E',
    fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
    boxSizing: 'border-box',
    padding: '24px 24px 112px',

    '@media (max-width: 720px)': {
      padding: '16px 14px 104px',
    },
  },

  shell: {
    width: '100%',
    maxWidth: '1180px',
    margin: '0 auto',
  },

  hero: {
    backgroundColor: '#0F3D2E',
    border: '1px solid rgba(201, 161, 74, 0.45)',
    borderRadius: '34px',
    padding: '30px',
    boxShadow: '0 22px 50px rgba(15, 61, 46, 0.16)',
    color: '#ffffff',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '24px',
    marginBottom: '22px',

    '@media (max-width: 720px)': {
      borderRadius: '28px',
      padding: '22px',
      flexDirection: 'column',
    },
  },

  heroTextBlock: {
    maxWidth: '760px',
  },

  kicker: {
    margin: '0 0 8px',
    color: '#C9A14A',
    fontSize: '12px',
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },

  title: {
    margin: 0,
    color: '#ffffff',
    fontSize: '44px',
    lineHeight: 1.04,
    letterSpacing: '-1.9px',
    fontWeight: '900',

    '@media (max-width: 720px)': {
      fontSize: '32px',
      letterSpacing: '-1.2px',
    },
  },

  subtitle: {
    maxWidth: '680px',
    margin: '14px 0 0',
    color: '#F4EBD8',
    fontSize: '15px',
    lineHeight: 1.75,

    '@media (max-width: 720px)': {
      fontSize: '14px',
    },
  },

  heroBadge: {
    width: '78px',
    height: '78px',
    minWidth: '78px',
    borderRadius: '50%',
    border: '2px solid #C9A14A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    boxShadow: '0 14px 30px rgba(0, 0, 0, 0.14)',

    '@media (max-width: 720px)': {
      width: '68px',
      height: '68px',
      minWidth: '68px',
    },
  },

  heroLogoImage: {
    width: '62px',
    height: '62px',
    objectFit: 'contain',
    display: 'block',

    '@media (max-width: 720px)': {
      width: '54px',
      height: '54px',
    },
  },

  contentCard: {
    backgroundColor: '#ffffff',
    border: '1px solid #E6D8BE',
    borderRadius: '32px',
    padding: '18px',
    boxShadow: '0 12px 34px rgba(30, 30, 30, 0.06)',

    '@media (max-width: 720px)': {
      borderRadius: '26px',
      padding: '14px',
    },
  },

  outletHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '16px',
    padding: '22px 4px 18px',

    '@media (max-width: 720px)': {
      flexDirection: 'column',
      padding: '18px 2px 14px',
    },
  },

  sectionKicker: {
    margin: '0 0 6px',
    color: '#C9A14A',
    fontSize: '11px',
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: '0.9px',
  },

  sectionTitle: {
    margin: 0,
    color: '#0F3D2E',
    fontSize: '24px',
    fontWeight: '900',
    letterSpacing: '-0.7px',

    '@media (max-width: 520px)': {
      fontSize: '21px',
    },
  },

  modePill: {
    backgroundColor: '#F4EBD8',
    color: '#0F3D2E',
    border: '1px solid #E6D8BE',
    borderRadius: '999px',
    padding: '9px 14px',
    fontSize: '12px',
    fontWeight: '900',
    whiteSpace: 'nowrap',
  },
});

export default HomePage;